import { render } from "./ObjectsNav.vue?vue&type=template&id=e9480b0c"
import script from "./ObjectsNav.vue?vue&type=script&lang=js"
export * from "./ObjectsNav.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__